import React from 'react';

const Object_Get_Set = () => {
  return (
    <div >
      <h1>Object_Get_Set</h1>
      <p>Placeholder component for: "Object Get / Set"</p>
    </div>
  );
};

export default Object_Get_Set;
